import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
	campaignDetailsStatusAtom,
	feedAdStatusAtom,
	formStatusAtom,
	landingPageStatusAtom,
	storyAdStatusAtom,
} from '../state'
import { ChatMessage, EditPanelChat } from './chat'

export function GeneratingEditArea() {
	const { t } = useTranslation('common')
	const detailsStatus = useAtomValue(campaignDetailsStatusAtom)
	const feedAdStatus = useAtomValue(feedAdStatusAtom)
	const storyAdStatus = useAtomValue(storyAdStatusAtom)
	const landingPageStatus = useAtomValue(landingPageStatusAtom)
	const formStatus = useAtomValue(formStatusAtom)

	const messages = useMemo<Array<ChatMessage>>(() => [
		{
			id: '0',
			type: 'bot' as const,
			content: t('editor.generating.building'),
		},
		{
			id: '1',
			type: 'multi-loader' as const,
			loaders: [
				{
					content: t('editor.generating.feedAdProgress'),
					doneContent: t('editor.generating.feedAdDone'),
					state: feedAdStatus === 'ready' ? 'done' as const : 'pending' as const,
				},
				{
					content: t('editor.generating.storyAdProgress'),
					doneContent: t('editor.generating.storyAdDone'),
					state: storyAdStatus === 'ready' ? 'done' as const : 'pending' as const,
				},
				{
					content: t('editor.generating.landingPageProgress'),
					doneContent: t('editor.generating.landingPageDone'),
					state: landingPageStatus === 'ready' ? 'done' as const : 'pending' as const,
				},
				{
					content: t('editor.generating.formProgress'),
					doneContent: t('editor.generating.formDone'),
					state: formStatus === 'ready' ? 'done' as const : 'pending' as const,
				},
				{
					content: t('editor.generating.imagesProgress'),
					doneContent: t('editor.generating.imagesDone'),
					state: detailsStatus === 'ready' ? 'done' as const : 'pending' as const,
				},
			],
		},
	], [t, detailsStatus, feedAdStatus, storyAdStatus, landingPageStatus, formStatus])

	return (
		<EditPanelChat
			messages={messages}
		/>
	)
}
